import { createAction, props } from '@ngrx/store';

import * as models from '../../domain/models';

export const load = createAction('[Sales.PeakDays] Load');
export const loadSuccess = createAction(
  '[Sales.PeakDays] Load Success',
  props<{ payload: models.PeakDays }>()
);
export const loadFail = createAction('[Sales.PeakDays] Load Fail');

export const setInitial = createAction('[Sales.PeakDays] Set Initial');
